import React from "react";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import DesignIllustration from "images/imgbg.png";
import TabCardGrid2 from "./cards/TabCardGrid2";
import { useState, useEffect } from 'react';
import Light from "./headers/light";
import LightAdmin from "./headers/lightAdmin";
import ServicesSection from "./ServicesSection";
import CatalogueDownload from "./CatalogueDownload";
import CategorieProducts from "./categories";
import BeautyCareHero from "./hero/BeautyCareHero";
import Categoriess from "./Categoriess";
import CategoriesSection from "./CategoriesSection";
import ForceOfNatureSection from "./ForceOfNatureSection";
import productImage from "../images/image prdts.png";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default () => {
    const { t } = useTranslation();
const { i18n } = useTranslation();

  const imageCss = tw`rounded-4xl`;
    const [role, setRole] = useState('');
  useEffect(() => {
      const userRole = localStorage.getItem('role');
      const user = localStorage.getItem('user');
          setRole(userRole); // Set the role state based on what’s stored
    }, []);
  const token = localStorage.getItem('authToken');
 const [productsAlimentaire, setProductsAlimentaire] = useState([]);
  const [cosmetique, setCosmetique] = useState([]);
  const [packs, setPacks] = useState([]);
    // Fetch Alimentaire products
    useEffect(() => {
      fetch(`https://elanciabioapi.com/api/alimentaire?lang=${i18n.language}`)
        .then((response) => response.json())
        .then((data) => setProductsAlimentaire(Array.isArray(data) ? data : []))
        .catch((error) => console.error("Error fetching products alimentaire:", error));
    }, []);
    useEffect(() => {
      fetch(`https://elanciabioapi.com/api/packs?lang=${i18n.language}`)
        .then((response) => response.json())
        .then((data) => setPacks(Array.isArray(data) ? data : []))
        .catch((error) => console.error("Error fetching products alimentaire:", error));
    }, []);
    // Fetch Cosmetique products
    useEffect(() => {
      fetch(`https://elanciabioapi.com/api/cosmetique?lang=${i18n.language}`)
        .then((response) => response.json())
        .then((data) => setCosmetique(Array.isArray(data) ? data : []))
        .catch((error) => console.error("Error fetching products cosmetique:", error));
    }, []);
  const navigate = useNavigate();
  return (
    <AnimationRevealPage>
{role === 'supplier' ? <Light /> : role === 'admin' ? <LightAdmin /> : <Light />}
      <Hero
        heading={<>BEAUTÉ & SANTÉ AU NATUREL</>}
        description="Révélez votre beauté intérieure et extérieure avec Élancia Bio.
Des produits naturels, sans compromis, pensés pour votre bien-être au quotidien."
imageSrc={DesignIllustration} 
imageCss={imageCss}
        imageDecoratorBlob={true}
        primaryButtonText="Découvrez nos produits"
        primaryButtonStyles="bg-red-500 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg"

      />
            <wbr />
      <wbr />

      <CategoriesSection />

<TabCardGrid2
      heading={t("products.cosmetics.heading")} // 👈 Use translation key
      products={cosmetique}
    />            
      <wbr />
                  <CatalogueDownload />

      <TabCardGrid2
      heading={t("products.complements.heading")} // 👈 Use translation key
  products={productsAlimentaire}
/>
      <wbr />
<ForceOfNatureSection
  imageSrc={productImage}
  onButtonClick={() => navigate("/boutique")}
/>
      <TabCardGrid2
      heading={t("products.packs.heading")} // 👈 Use translation key
  products={packs}
/>
      <Footer />
    </AnimationRevealPage>
  );
}
